// extracted by mini-css-extract-plugin
export var borderRadius = "_b1-4";
export var large = "_b1-3";
export var logoContainer = "_b1-0";
export var nameLogo = "_b1-2";
export var small = "_b1-1";